<p>time-switch-display works!</p>
